import { useFetchJson } from "shared/fetch/useFetchJson";
import { getQueryStringValueWithType } from "shared/url/getQueryStringValue";
import { useRunOnMount } from "shared/useRunOnMount/useRunOnMount";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { SiteSurvey } from "api/types/siteSurvey";
import { useState } from "react";
import { getEmptySurvey } from "api/getEmptySurvey";
import { fetchJson } from "shared/fetch/fetchJson";
import { useAbortController } from "shared/useAbortController";
import Loading from "shared/loading";
import { SurveyForm } from "./surveyForm";

export default function SurveyPage({
  action,
}: {
  action: "editSurvey" | "editUnit";
}) {
  const surveyId = getQueryStringValueWithType("id");
  const unitId = getQueryStringValueWithType<number>("unitId", "int");

  const { run: fetchSiteConfig, data: config } =
    useFetchJson<SiteSurveyConfiguration>();
  const [survey, setSurvey] = useState<SiteSurvey>();
  const abortController = useAbortController();

  useRunOnMount(() => {
    async function load() {
      fetchSiteConfig("/api/SiteSurveyConfiguration/Get");
      if (surveyId) {
        const { data } = await fetchJson<SiteSurvey>(
          `/api/siteSurvey/get?siteSurveyId=${surveyId}`,
          {
            signal: abortController.signal,
          }
        );
        setSurvey(data);
      } else {
        setSurvey(getEmptySurvey() as SiteSurvey);
      }
    }
    load();
  });

  if (!survey || !config) {
    return <Loading />;
  }
  return (
    <div>
      {config && survey && (
        <div className="row justify-content-center mt-3">
          <div className="col-md-8 col-lg-10">
            <SurveyForm
              config={config}
              survey={survey}
              action={action}
              unitId={unitId}
            />
          </div>
        </div>
      )}
    </div>
  );
}
